module.exports = __webpack_public_path__ + "03_face.1f7b96b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer1/03_face.png
// module id = /nKf
// module chunks = 0